import { render, staticRenderFns } from "./ShowClock.vue?vue&type=template&id=36026c68"
import script from "./ShowClock.vue?vue&type=script&lang=js"
export * from "./ShowClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports